import { API_AUTH } from "./common";

const NoPhaiThuApi = {
  list: ({
    dateTo,
    code,
    customerName,
    address,
    debt,
    userName = "0",
    trangThaiGiaHan = "0",
    kieuvay = "0",
    tienVay = "",
    typeNgayPhaiTra = "0",
    pageIndex,
    pageSize,
    manhanvien,
    optionDateMB = "",
    sapxep,
  }) =>
    API_AUTH.get(
      `nophaithu/danh-sach-no-phai-thu1?tenKhachHang=${customerName}&kieuvay=${kieuvay}&tienVay=${tienVay}&maTaiSan=${code}&user=${userName}&debtLevel=${debt}&trangThaiGiaHan=${trangThaiGiaHan}&diaChi=${address}&denNgay=${dateTo}&typeNgayPhaiTra=${typeNgayPhaiTra}&sapxep=${sapxep}&optionDateMB=${optionDateMB}&pageIndex=${pageIndex}&pageSize=${pageSize}&maNhanVien=${manhanvien}`,
      {}
    ),
  xoaGiaHanNo: (ChoVayID, NoGiaHanID) => {
    return API_AUTH.post(
      `nophaithu/xoa-gia-han-no?ChoVayID=${ChoVayID}&NoGiaHanID=${NoGiaHanID}`,
      {}
    );
  },
  editGiaHanNo: (params) => API_AUTH.post("nophaithu/luu-gia-han-no", params),
};

export default NoPhaiThuApi;
